var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVKontakte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z",
    fill: "#0077FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 24.04C7 16.0052 7 11.9937 9.485 9.485C12.0055 7 16.017 7 24.04 7H25.46C33.4948 7 37.5063 7 40.015 9.485C42.5 12.0055 42.5 16.017 42.5 24.04V25.46C42.5 33.4948 42.5 37.5063 40.015 40.015C37.4945 42.5 33.483 42.5 25.46 42.5H24.04C16.0052 42.5 11.9937 42.5 9.485 40.015C7 37.4945 7 33.483 7 25.46V24.04Z",
    fill: "#0077FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.886 32.5718C17.792 32.5718 13.177 27.0338 12.9877 17.8038H17.0583C17.1885 24.5725 20.1705 27.4362 22.5372 28.0278V17.8038H26.3593V23.6377C28.6905 23.3892 31.1518 20.7267 31.9802 17.792H35.7905C35.4798 19.3111 34.8592 20.7498 33.9674 22.0183C33.0756 23.2868 31.9318 24.3577 30.6075 25.1642C32.0854 25.8997 33.3906 26.9403 34.437 28.2171C35.4833 29.494 36.2471 30.9782 36.678 32.5718H32.4772C31.5778 29.7673 29.3295 27.59 26.3593 27.2942V32.5718H25.8978H25.886Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVKontakte);
export default __webpack_public_path__ + "static/media/VKontakte.4977f9a454c292cad7f854fe7a77bfa4.svg";
export { ForwardRef as ReactComponent };